import { PlanService } from "./plan.service";

export const planService = new PlanService()